/* SUMMARY
  * Imports
  * useTablePageSize: la taille de page courante, réactive
*/

/* Imports */
import { useEffect, useState } from "react";
import {
  DEFAULT_TABLE_PAGE_SIZE,
  TABLE_PAGE_SIZE_EVENT,
  readTablePageSize
} from "../services/preferences/tablePageSize";
/***/

/**
* useTablePageSize: le nombre de lignes par page à afficher.
*
* La lecture se fait dans l'initialiseur paresseux de `useState`, donc **dès le premier rendu** :
* c'est tout l'intérêt du miroir local. Lire dans un `useEffect` rendrait d'abord 20 lignes puis
* re-rendrait à 50, et chacun des quinze écrans relancerait une requête pour rien.
*
* Deux sources de changement, parce qu'elles ne se recouvrent pas : `TABLE_PAGE_SIZE_EVENT` pour le
* profil modifié dans le même onglet, et `storage` pour un autre onglet du même navigateur.
*
* @return - la taille courante, directement utilisable dans un tableau de dépendances
*/
export function useTablePageSize(): number {
  const [pageSize, setPageSize] = useState<number>(() => readTablePageSize());

  useEffect(() => {
    const sync = () => setPageSize(readTablePageSize());

    window.addEventListener(TABLE_PAGE_SIZE_EVENT, sync);
    window.addEventListener("storage", sync);

    // Le miroir a pu changer entre l'initialiseur et l'abonnement — la réconciliation au démarrage
    // écrit tôt. Une relecture ici évite de rester sur une valeur périmée d'un cheveu.
    sync();

    return () => {
      window.removeEventListener(TABLE_PAGE_SIZE_EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  return pageSize;
}
/***/

export { DEFAULT_TABLE_PAGE_SIZE };
